import { Injectable } from '@angular/core';
import { IID_OL_APPUNTAMENTO } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDolAppuntamentoQuery } from './iidOlAppuntamento.query';
import { IIDolAppuntamentoStore } from './iidOlAppuntamento.store';
import { WsACKCallback } from '@common/api/ack';
import { PartialUpdate } from '@common/interfaces/base';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

const TOPIC = Topics.IID_OL_APPUNTAMENTO;

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.APPUNTAMENTO)
export class IIDolAppuntamentoService extends CrudService<IID_OL_APPUNTAMENTO, IIDolAppuntamentoStore, IIDolAppuntamentoQuery> {
  constructor(
    protected store: IIDolAppuntamentoStore,
    public query: IIDolAppuntamentoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(Topics.IID_OL_APPUNTAMENTO, store, query, actionService, updateStrategy);
  }

  reassignUser(issueId: string, newUserId: string) {
    if (!issueId || !newUserId) {
      return;
    }
    const oloAppuntamento = this.query.getOneByIssueId(issueId);
    if (oloAppuntamento && oloAppuntamento.userId !== newUserId) {
      this.update({ id: oloAppuntamento.id, userId: newUserId });
    }
  }

  retry(id: string, callback?: WsACKCallback) {
    const dto = { id };
    this.featureCommandService.send(
      {
        target: 'feature:ol-appuntamento',
        command: 'retry',
        dto,
        ...this.projectIdFromEntity(id),
      },
      () => this.actionService.sendMessage(TOPIC, 'retry', dto, callback),
      callback,
    );
  }

  private projectIdFromEntity(id: string): { projectId?: string } {
    const projectId = this.query.getEntity(id)?.projectId;
    return projectId ? { projectId } : {};
  }
}
